import IndexesSlideAnimator from './indexes-slide-animator';

class OffsetsSlideAnimator extends IndexesSlideAnimator {
	constructor({
		positionVar = '--slidePosition',
		balancedPositionVar = '--slideBalancedPosition',
		offsetVar = '--slideOffset',
		centerOffsetVar = '--slideCenterOffset',
		widthRatioVar = '--slideWidthRatio',
		animateClass = 'animate',
	} = {}) {
		super({positionVar: positionVar, balancedPositionVar: balancedPositionVar, animateClass: animateClass});
		this.offsetVar = offsetVar;
		this.centerOffsetVar = centerOffsetVar;
		this.widthRatioVar = widthRatioVar;
	}

	recalculatePositions(offset, balancedOffset, balancedUpperLimit, balancedLowerLimit, balancedDirection, positionReMap, balancedPositionReMap) {
		super.recalculatePositions(offset, balancedOffset, balancedUpperLimit, balancedLowerLimit, balancedDirection, positionReMap, balancedPositionReMap);
		this.recalculateOffsets();
	}

	finalizeSwitch(positionReMap, balancedPositionReMap) {
		super.finalizeSwitch(positionReMap, balancedPositionReMap);
		this.recalculateOffsets();
	}

	recalculateOffsets() {
		const styles = [];
		const map = {};
		let i = 0;
		for (const slideElement of this.slidesElements) {
			const style = slideElement.style;
			const pos = parseInt(style.getPropertyValue(this.balancedPositionVar), 10);
			styles[i] = {style: style, pos: pos};
			map[pos] = i;
			i++;
		}
		styles.sort((a, b) => {
			if (a.pos >= 0 && b.pos >= 0) {
				return a.pos - b.pos;
			}
			if (a.pos < 0 && b.pos < 0) {
				return b.pos - a.pos;
			}
			return b.pos - a.pos;
		});

		let prev = null;
		for (const entry of styles) {
			const pos = entry.pos;
			const style = entry.style;
			let offset = 0;
			let centerOffset = -(style.getPropertyValue(this.widthRatioVar) / 2);

			if (pos > 0) {
				offset = parseFloat(prev.getPropertyValue(this.widthRatioVar)) + parseFloat(prev.getPropertyValue(this.offsetVar));
				centerOffset = parseFloat(prev.getPropertyValue(this.widthRatioVar)) + parseFloat(prev.getPropertyValue(this.centerOffsetVar));
			} else if (pos < 0) {
				if (pos === -1) {
					offset = parseFloat(styles[0].style.getPropertyValue(this.offsetVar)) - parseFloat(style.getPropertyValue(this.widthRatioVar));
					centerOffset = parseFloat(styles[0].style.getPropertyValue(this.centerOffsetVar)) - parseFloat(style.getPropertyValue(this.widthRatioVar));
				} else {
					offset = parseFloat(prev.getPropertyValue(this.offsetVar)) - parseFloat(style.getPropertyValue(this.widthRatioVar));
					centerOffset = parseFloat(prev.getPropertyValue(this.centerOffsetVar)) - parseFloat(style.getPropertyValue(this.widthRatioVar));
				}
			}
			style.setProperty(this.offsetVar, offset);
			style.setProperty(this.centerOffsetVar, centerOffset);
			prev = style;
		}
	}
}

export default OffsetsSlideAnimator;
